import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { ContextualHistoryService } from '../../content/general/contextual-history/services/contextual-history.service';
import { RelatedView } from '../../content/general/contextual-history/enums';

@Component({
  selector: 'kt-timeline-offcanvas',
  templateUrl: './timeline-offcanvas.component.html',
  styleUrls: ['./timeline-offcanvas.component.scss'],
})
export class TimelineOffcanvasComponent {
  relatedView$: Observable<RelatedView | ''>;
  RelatedView = RelatedView;
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_timeline_close',
    toggleBy: 'kt_timeline_toggle',
  };

  constructor(private contextualHistoryService: ContextualHistoryService) {
    this.relatedView$ = this.contextualHistoryService.relatedViewSub.asObservable();
  }
}
